import { useCallback, useEffect, useState } from 'react';
import {Sprig} from 'sprig';
import {Api} from "../../store/api";
import {useSession, useUser} from "@clerk/clerk-react";
import toast from "react-hot-toast";

interface UserObject {
    user_profile?: any;
    [key: string]: any;
}


function displayChurnkeyPauseWall(user_profile, fetchUserProfile) {
    console.log(user_profile)
    try {
        // @ts-ignore
        const manageSubscription = user_profile?.manage_subscription || {};
        // @ts-ignore
        window.churnkey.check('pause', {
            // Required - Authentication & identification
            customerId: manageSubscription?.stripe_customer_id,
            authHash: manageSubscription?.churnkey_hash,
            appId: '2l1cnhdje',
            provider: 'stripe',        // or 'chargebee'

            // Optional - Wall behavior
            mode: process.env.NODE_ENV === 'production' ? 'live' : 'test',
            softWall: true,          // Allow users to exit the wall
            forceCheck: false,         // Skip caching (not recommended)
            onPauseWallClose: () => { fetchUserProfile(); },
        });
    } catch (error) {
        // pass
    }
}


// adds our user_profile object to the auth user object
export default function useUserObject() {
    const [userObject, setUserObject] = useState<UserObject>({});
    const { isLoaded, isSignedIn, session } = useSession();
    const { user: clerkUser } = useUser();

    const fetchUserProfile = useCallback(async () => {
        if (isLoaded && session && isSignedIn) {
            const { user } = session;
            // Preserve user_profile when setting clerk user data
            setUserObject(prevState => ({
                ...user,
                user_profile: prevState.user_profile
            }));

            // Sign up tolt referral
            // https://help.tolt.io/en/articles/6904174-how-to-signup-a-referral
            // This assumes calling tolt sign up many times for same email is ok
            // @ts-ignore
            if (window.tolt_referral) {
                // @ts-ignore
                window.tolt.signup(user['email'])
            }

            // Identify Sprig user
            await Sprig.setUserId(user.id);
            await Sprig.setEmail(user['email']);

            // Get UserProfile
            if (user) {
                Api.getUserProfile().then(data => {
                    setUserObject((prevUserObj) => ({
                        ...prevUserObj,
                        user_profile: data.data,
                    }));
                    displayChurnkeyPauseWall(data.data, fetchUserProfile)
                }).catch(() => {
                    toast.error('Failed to get User Profile')
                })
            }
        }
    }, [isLoaded, isSignedIn, session])

    useEffect(() => {
        fetchUserProfile();
    }, [fetchUserProfile, clerkUser]);

    return { user: userObject, refetchUser: fetchUserProfile };
}